<template>
    <div>
        <div class="form-group col-12" v-show="showSinitreBouton">
            <div class="app-block app-block-shadow bg-white marginAuto">
                <div class=""></div>
                <div class="app-wrapper app-wrapper-small mt-2">
                    <div class="app-block-richtext app-richtext">
                        <h3 class="text-primary font-weight-normal h3Minus">
                            Votre demande concerne-t-elle un sinistre ?
                        </h3>
                    </div>
                    <br>

                    <div class="form-row d-flex align-items-center">
                        <div class="form-group col-12 col-md-6">
                            <a href="#" v-on:click="goToSinistre" class="app-button w-100
                                app-button w-100 BT_ACTION" categorie="Contact Site" action="Filtre" libelle="Choix sinistre"><span class="app-button-text">Oui</span></a>
                        </div>
                        <div class="form-group col-12 col-md-6">
                            <div class="row">
                                <div class="col-12">
                                    <a href="#" v-on:click="goToForm" class="app-button w-100
                                app-button w-100 BT_ACTION" categorie="Contact Site" action="Filtre" libelle="Choix contact"><span
                                        class="app-button-text">Non</span></a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="app-block bg-alabaster border border-alto" v-show="showRedirect">
            <div class="app-richtext app-richtext">
                <h3>
                    Votre demande <span class="text-primary">concerne un sinistre</span>
                </h3>
                <div class="app-cluster pt-0">
                    <div class="app-cluster-item app-cluster-item-fluid">
                        <div class="app-richtext">
                            Pour la gestion de vos sinitres, merci de vous rendre sur la page :
                            <div class="mt-3 pt-3" align="center">
                                <a :href="lienSinistre" aria-label="En cas de sinistre" class="app-header-link d-inline"
                                   style="border: 0.0625rem solid #d8d8d8;">
                                    <svg width="18" height="18" class="app-header-icon app-icon">
                                        <use xlink:href="/images/lunaweb/app/sprite.svg#sprite-medical-cross"></use>
                                    </svg>
                                    <span class="app-header-label">En cas de sinistre</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FormContactSinistreComponent",

    props: {
        lienSinistre: String
    },

    data() {
        return {
            valeurRadioSinistre: '',
            showRedirect: false,
            showSinitreBouton: true,
        }
    },

    mounted() {
        $('.recherche_agence_conseiller_form').css("display", 'none');
        this.showRedirect = false;
        this.showSinitreBouton = true;
    },

    methods: {

        goToForm: function () {
            $('.recherche_agence_conseiller_form').css("display", 'block');
            this.showRedirect = false;
            this.showSinitreBouton = false;
        },

        goToSinistre: function () {
            $('.recherche_agence_conseiller_form').css("display", 'none');
            this.showRedirect = true;
            this.showSinitreBouton = false;
        },

    },

}
</script>

<style scoped>

</style>
